import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-financials-workspace',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  templateUrl: './financials-workspace.component.html',
})
export class FinancialsWorkspaceComponent {
  readonly sections = [
    { label: 'Overview', path: 'overview' },
    { label: 'Accounts', path: 'accounts' },
    { label: 'Banking', path: 'banking' },
    { label: 'Transactions', path: 'transactions' },
    { label: 'Tax', path: 'tax' },
    { label: 'Reports', path: 'reports' },
    { label: 'Setup', path: 'setup' },
  ];
}
